import { useContext, useMemo } from 'react';
import MembersContext from 'router/subrouters/DataRoom/providers/Members/Members.context';

export default function useMembers(onlyNew = false) {
  const {
    sellSideMembers,
    sellSideNewMembers,
    buySideMembers,
    buySideNewMembers,
    buySideGroups,
    buySideGroupWithNewMembers,
  } = useContext(MembersContext);

  const sellMembers = useMemo(
    () => (onlyNew ? sellSideNewMembers : sellSideMembers),
    [onlyNew, sellSideMembers, sellSideNewMembers],
  );

  const buyMembers = useMemo(
    () => (onlyNew ? buySideNewMembers : buySideMembers),
    [buySideMembers, buySideNewMembers, onlyNew],
  );

  const buyGroups = useMemo(
    () => (onlyNew ? buySideGroupWithNewMembers : buySideGroups),
    [buySideGroupWithNewMembers, buySideGroups, onlyNew],
  );

  return {
    sellSideMembers: sellMembers,
    buySideMembers: buyMembers,
    buySideGroups: buyGroups,
  };
}
